import { getIn, useFormikContext } from 'formik';

import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';

import { EMPTY_STRING } from '@e-socna/empty';

import { getTouchedError } from '../../../../utils/get-touched-error.util';
import type { AddressForm } from '../../types/address-form.type';

interface Props {
  readonly id: string;
}

// eslint-disable-next-line no-empty-pattern
export const AddressCadastralInfoFormStep = ({}: Readonly<Props>) => {
  const { errors, handleBlur, handleChange, touched, values } =
    useFormikContext<AddressForm>();

  return (
    <Grid container spacing={2} sx={{ alignContent: 'flex-start' }}>
      <Grid
        size={{
          sm: 4,
          xs: 12,
        }}
        sx={{ pt: 1, pb: 1 }}
      >
        <TextField
          error={
            !!(
              getIn(errors, 'cadastralInfo.departmentCode') &&
              getIn(touched, 'cadastralInfo.departmentCode')
            )
          }
          fullWidth
          helperText={getTouchedError(
            errors,
            touched,
            'cadastralInfo.departmentCode',
          )}
          id="address-cadastral-info-department-code"
          label="Code INSEE Département"
          name="cadastralInfo.departmentCode"
          onBlur={handleBlur}
          onChange={handleChange}
          required
          type="text"
          value={values.cadastralInfo?.departmentCode ?? EMPTY_STRING}
          variant="outlined"
        />
      </Grid>
      <Grid
        size={{
          sm: 4,
          xs: 12,
        }}
        sx={{ pt: 1, pb: 1 }}
      >
        <TextField
          error={
            !!(
              getIn(errors, 'cadastralInfo.municipalityCode') &&
              getIn(touched, 'cadastralInfo.municipalityCode')
            )
          }
          fullWidth
          helperText={getTouchedError(
            errors,
            touched,
            'cadastralInfo.municipalityCode',
          )}
          id="address-cadastral-info-municipality-code"
          label="Code INSEE Commune"
          name="cadastralInfo.municipalityCode"
          onBlur={handleBlur}
          onChange={handleChange}
          required
          type="text"
          value={values.cadastralInfo?.municipalityCode ?? EMPTY_STRING}
          variant="outlined"
        />
      </Grid>
      <Grid
        size={{
          sm: 4,
          xs: 12,
        }}
        sx={{ pt: 1, pb: 1 }}
      >
        <TextField
          error={
            !!(
              getIn(errors, 'cadastralInfo.oldMunicipalityCode') &&
              getIn(touched, 'cadastralInfo.oldMunicipalityCode')
            )
          }
          fullWidth
          helperText={
            getIn(errors, 'cadastralInfo.oldMunicipalityCode') as string
          }
          id="address-cadastral-info-old-municipality-code"
          label="Commune Absorbée"
          name="cadastralInfo.oldMunicipalityCode"
          onBlur={handleBlur}
          onChange={handleChange}
          required
          type="text"
          value={values.cadastralInfo?.oldMunicipalityCode ?? EMPTY_STRING}
          variant="outlined"
        />
      </Grid>
      <Grid
        size={{
          sm: 6,
          xs: 12,
        }}
        sx={{ pt: 1, pb: 1 }}
      >
        <TextField
          error={
            !!(
              getIn(errors, 'cadastralInfo.districtCode') &&
              getIn(touched, 'cadastralInfo.districtCode')
            )
          }
          fullWidth
          helperText={getTouchedError(
            errors,
            touched,
            'cadastralInfo.districtCode',
          )}
          id="address-cadastral-info-district-code"
          label="Arrondissement"
          name="cadastralInfo.districtCode"
          onBlur={handleBlur}
          onChange={handleChange}
          required
          type="text"
          value={values.cadastralInfo?.districtCode ?? EMPTY_STRING}
          variant="outlined"
        />
      </Grid>
      <Grid
        size={{
          sm: 6,
          xs: 12,
        }}
        sx={{ pt: 1, pb: 1 }}
      >
        <TextField
          error={
            !!(
              getIn(errors, 'cadastralInfo.section') &&
              getIn(touched, 'cadastralInfo.section')
            )
          }
          fullWidth
          helperText={getTouchedError(errors, touched, 'cadastralInfo.section')}
          id="address-cadastral-info-section"
          label="Section"
          name="cadastralInfo.section"
          onBlur={handleBlur}
          onChange={handleChange}
          required
          type="text"
          value={values.cadastralInfo?.section ?? EMPTY_STRING}
          variant="outlined"
        />
      </Grid>
      <Grid
        size={{
          sm: 6,
          xs: 12,
        }}
        sx={{ pt: 1, pb: 1 }}
      >
        <TextField
          error={
            !!(
              getIn(errors, 'cadastralInfo.number') &&
              getIn(touched, 'cadastralInfo.number')
            )
          }
          fullWidth
          helperText={getTouchedError(errors, touched, 'cadastralInfo.number')}
          id="address-cadastral-info-number"
          label="Numéro"
          name="cadastralInfo.number"
          onBlur={handleBlur}
          onChange={handleChange}
          required
          type="text"
          value={values.cadastralInfo?.number ?? EMPTY_STRING}
          variant="outlined"
        />
      </Grid>
      <Grid
        size={{
          sm: 6,
          xs: 12,
        }}
        sx={{ pt: 1, pb: 1 }}
      >
        <TextField
          error={
            !!(
              getIn(errors, 'cadastralInfo.sheet') &&
              getIn(touched, 'cadastralInfo.sheet')
            )
          }
          fullWidth
          helperText={getTouchedError(errors, touched, 'cadastralInfo.sheet')}
          id="address-cadastral-info-sheet"
          label="Feuille"
          name="cadastralInfo.sheet"
          onBlur={handleBlur}
          onChange={handleChange}
          required
          slotProps={{ htmlInput: { min: 0, step: 1 } }}
          type="number"
          value={values.cadastralInfo?.sheet ?? EMPTY_STRING}
          variant="outlined"
        />
      </Grid>
    </Grid>
  );
};
